import { useState } from 'react';
import { Link } from 'react-router-dom';

import { useWeightLogsQuery } from '../hooks/useWeightLogs.js';

/**
 * Section 4c of /review V2 (spec §5.Section 4 → 4c). Shows every weight
 * entry the user has logged, descending. Empty state nudges toward the
 * weight-log form on /profile (where the existing weight widget lives).
 */
export function ReceiptsWeightBlock() {
  const [open, setOpen] = useState(false);
  const weightQuery = useWeightLogsQuery({ pageSize: 20 });
  const items = weightQuery.data?.items ?? [];
  const total = weightQuery.data?.total ?? items.length;
  const summary = total === 0 ? 'No entries yet' : `${total} ${total === 1 ? 'entry' : 'entries'}`;

  return (
    <article className="review-receipt">
      <button
        type="button"
        className="review-receipt__toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="review-receipt__title">Weight</span>
        <span className="review-receipt__summary">{summary}</span>
        <span className="review-receipt__chevron" aria-hidden>
          ▾
        </span>
      </button>

      {open ? (
        <div className="review-receipt__body">
          {items.length === 0 ? (
            <div className="review-receipt__empty-block">
              <p className="review-receipt__empty">No weight logs yet.</p>
              <Link to="/profile" className="btn-primary">
                Log weight
              </Link>
            </div>
          ) : (
            <ul className="review-weight">
              {items.map((w) => (
                <li key={w.id} className="review-weight__row">
                  <span className="review-weight__date">{formatDate(w.loggedAt)}</span>
                  <span className="review-weight__value">{w.weightKg.toFixed(1)} kg</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : null}
    </article>
  );
}

function formatDate(iso: string): string {
  const dt = new Date(iso);
  return dt.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
